import React, { FC } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import SpecCheckPluginContainer from '../@shared/specCheckPluginContainer';
import { SpecCheckProps } from './types/specCheck.types';
import { SpecCheckModel } from './models/specCheck.model';

const SpecCheck: FC<SpecCheckProps> = (props) => {
  const model: SpecCheckModel = new SpecCheckModel(props);

  if (!model?.embedId) {
    return isEditorActive() ? <EmptyApiDataMessage componentName={model.componentName} /> : <></>;
  }

  return <SpecCheckPluginContainer embedId={model?.embedId} />;
};

export default SpecCheck;
